import React from 'react'
import SelectList from 'shared/components/form/ui/select-list'
import styled from 'styled-components'

const ContentSelectList = styled(SelectList)`
    width: 215px;
    position: relative;
`

const values: string[] = ['GIFs & Stickers', 'Clips', 'GIFs', 'Stickers', 'Stories']
const newItems: string[] = ['Clips']

type Props = {
    onChange: (type: string) => void
}

const ContentTypePicker = ({ onChange = () => {} }: Props) => (
    <ContentSelectList
        options={values}
        title={'CONTENT TYPE'}
        placeholder={'Choose a Content Type'}
        theme={'dark'}
        allowMultiple={false}
        onChange={onChange}
        new={newItems}
    />
)

export default ContentTypePicker
